<template>
  <b-sidebar id="add-new-service-code-sidebar" :visible="isAddNewServiceCodeSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-service-code-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ button_text }} 項目類型</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay :show='loading' spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
          <!-- Form -->
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <!-- 項目類型代碼-->
            <validation-provider #default="validationContext" name="項目類型代碼" rules="required|max:6">
              <b-form-group label="項目類型代碼" label-for="service-code">
                <b-form-input id="service-code" v-model="servicecodeData.service_code" autofocus
                  :state="getValidationState(validationContext)" trim placeholder="項目類型代碼" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- 項目類型 -->
            <validation-provider #default="validationContext" name="項目類型" rules="required|max:90">
              <b-form-group label="項目類型" label-for="name">
                <b-form-textarea id="name" v-model="servicecodeData.name"
                  placeholder="Display in project" autofocus :state="getValidationState(validationContext)" trim />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

              <b-form-group label="描述" label-for="description">
                <b-form-textarea
                id="description"
                v-model="servicecodeData.description"
                autofocus
                trim
              />
              </b-form-group>



            <!-- Is Active -->
            <b-form-group>
              <b-form-checkbox checked="true" name="check-button" switch inline v-model="servicecodeData.is_active" value="1" >
                狀態
              </b-form-checkbox>
            </b-form-group>
            <!-- Form Actions -->

            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
                {{ button_text }}
              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
                @click="hide">
                Cancel
              </b-button>
            </div>

          </b-form>
        </b-overlay>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js"
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    vSelect,
    BOverlay,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewServiceCodeSidebarActive',
    event: 'update:is-add-new-service-code-sidebar-active',
  },
  props: {
    isAddNewServiceCodeSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      max,
    }
  },
  setup(props, { emit }) {

    const loading = ref(false)

    const blankServiceCodeData = {
      id: 0,
      service_code: '',
      description: '',
      is_active: 1,
    }
    const button_text = ref('新增')

    const servicecodeData = ref(JSON.parse(JSON.stringify(blankServiceCodeData)))

    const resetservicecodeData = () => {
      servicecodeData.value = JSON.parse(JSON.stringify(blankServiceCodeData))
    }

    const toast = useToast()

    watch(() => [props.id, props.isAddNewServiceCodeSidebarActive], () => {
      if (props.id > 0 && props.isAddNewServiceCodeSidebarActive) {
        servicecodeData.value = {...props.data}
        if (servicecodeData.value.id > 0) {
          button_text.value = '修改'
        } else {
          button_text.value = '新增'
        }
      } else {
        button_text.value = '新增'
      }


    })

    const onSubmit = () => {
      loading.value = true
      store.dispatch("setting-servicecode/addServiceCode", servicecodeData.value)
        .then((response) => {
          loading.value = false
          emit("update:is-add-new-service-code-sidebar-active", false);
          emit('refetch-data')
          toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              text: response.data.message,
              icon: 'CheckIcon',
              variant: 'success'
            }
          })
        })
        .catch((error) => {
          loading.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Fail',
              text: error.response.data.message,
              icon: 'HeartIcon',
              variant: 'danger'
            }
          })
        })
    };

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetservicecodeData)

    return {
      servicecodeData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      button_text,
      loading,
    };


  }

};
</script>

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-service-code-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>